var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSvgmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 266.13 160.69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "al"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320.68 272.55h9.385v-9.384h-9.385z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m336.78 272.55h9.387v-9.384h-9.387z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m352.89 272.55h9.384v-9.384h-9.384z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m368.99 272.55h9.385v-9.384h-9.385z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m385.09 272.55h9.387v-9.384h-9.387z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m401.2 272.55h9.386v-9.384h-9.386z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "M 0,595.276 H 841.89 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-427.21 -317.26)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m327.77 244.67c-0.283 1.442-1.607 2.589-3.109 2.589-1.532 0-2.885-1.086-3.152-2.589zm-6.261-0.995c0.059-1.548 1.561-2.811 3.063-2.811 1.205 0 2.424 0.668 2.915 1.785h1.145c-0.565-1.638-2.231-2.84-3.956-2.84-2.38 0-4.268 1.872-4.268 4.252 0 2.364 1.873 4.255 4.238 4.255 1.28 0 2.455-0.581 3.272-1.579 0.759-0.937 0.921-1.887 0.952-3.062z",
    clipPath: "url(#ac)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m332.87 248.13h1.041v-1.174h0.03c0.595 0.877 1.428 1.354 2.498 1.354 1.086 0 2.158-0.477 2.886-1.354 0.624-0.789 0.743-1.651 0.743-2.677v-4.283h-1.1v4.283c0 0.698-0.06 1.354-0.476 1.933-0.49 0.683-1.264 1.041-2.097 1.041-0.759 0-1.546-0.37-1.993-0.995-0.431-0.58-0.417-1.296-0.431-1.979v-4.283h-1.101z",
    clipPath: "url(#r)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m345.21 244.15c0-1.799 1.265-3.287 3.123-3.287 0.862 0 1.621 0.283 2.231 0.923 0.551 0.579 0.922 1.472 0.922 2.274 0 1.83-1.443 3.198-3.258 3.198-1.694 0-3.018-1.444-3.018-3.108m7.347-2.989c0-1.265-0.045-2.037-0.952-3.019-0.788-0.863-2.053-1.325-3.213-1.325-1.784 0-3.539 1.206-3.984 2.991h1.069c0.641-1.205 1.607-1.934 3.005-1.934 1.041 0 2.126 0.474 2.661 1.411 0.357 0.641 0.357 1.16 0.357 1.876v0.444c-0.52-1.218-1.918-1.797-3.182-1.797-1.071 0-2.156 0.461-2.93 1.189-0.862 0.819-1.278 1.858-1.278 3.047 0 1.145 0.475 2.188 0.773 2.516 1.071 1.351 2.215 1.755 3.376 1.755 1.293 0 2.617-0.581 3.241-1.755v1.575h1.057z",
    clipPath: "url(#e)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m356.92 248.13h1.102v-8.134h-1.102zm0 2.856h1.102v-1.876h-1.102z",
    clipPath: "url(#a)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m362.37 248.13h1.041v-1.174h0.03c0.595 0.877 1.428 1.354 2.498 1.354 1.086 0 2.158-0.477 2.886-1.354 0.624-0.789 0.744-1.651 0.744-2.677v-4.283h-1.1v4.283c0 0.698-0.061 1.354-0.477 1.933-0.491 0.683-1.264 1.041-2.097 1.041-0.758 0-1.546-0.37-1.993-0.995-0.43-0.58-0.417-1.296-0.43-1.979v-4.283h-1.102z",
    clipPath: "url(#am)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m380.98 244.67c-0.282 1.442-1.606 2.589-3.109 2.589-1.531 0-2.885-1.086-3.152-2.589zm-6.261-0.995c0.059-1.548 1.562-2.811 3.064-2.811 1.204 0 2.424 0.668 2.915 1.785h1.144c-0.564-1.638-2.23-2.84-3.955-2.84-2.38 0-4.268 1.872-4.268 4.252 0 2.364 1.873 4.255 4.238 4.255 1.278 0 2.454-0.581 3.272-1.579 0.759-0.937 0.921-1.887 0.952-3.062z",
    clipPath: "url(#al)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m393.13 244.67c-0.282 1.442-1.607 2.589-3.109 2.589-1.532 0-2.885-1.086-3.152-2.589zm-6.261-0.995c0.059-1.548 1.561-2.811 3.064-2.811 1.204 0 2.423 0.668 2.915 1.785h1.144c-0.565-1.638-2.231-2.84-3.956-2.84-2.38 0-4.267 1.872-4.267 4.252 0 2.364 1.872 4.255 4.238 4.255 1.279 0 2.453-0.581 3.271-1.579 0.759-0.937 0.922-1.887 0.952-3.062z",
    clipPath: "url(#ak)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m398.23 248.13h1.041v-1.174h0.03c0.402 0.965 1.339 1.323 2.336 1.354v-1.087c-0.595-0.043-1.012-0.179-1.474-0.565-0.757-0.64-0.831-1.189-0.831-2.112v-4.55h-1.102z",
    clipPath: "url(#aj)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m405.19 248.13h1.101v-8.134h-1.101zm0 2.856h1.101v-1.876h-1.101z",
    clipPath: "url(#ai)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m410.65 248.13h1.041v-1.174h0.031c0.594 0.877 1.427 1.354 2.498 1.354 1.086 0 2.157-0.477 2.886-1.354 0.624-0.789 0.743-1.651 0.743-2.677v-4.283h-1.1v4.283c0 0.698-0.06 1.354-0.476 1.933-0.492 0.683-1.265 1.041-2.098 1.041-0.758 0-1.546-0.37-1.992-0.995-0.431-0.58-0.417-1.296-0.431-1.979v-4.283h-1.102z",
    clipPath: "url(#ah)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m422.99 244.15c0-1.799 1.264-3.287 3.124-3.287 0.863 0 1.618 0.283 2.228 0.923 0.552 0.579 0.923 1.472 0.923 2.274 0 1.83-1.442 3.198-3.257 3.198-1.695 0-3.018-1.444-3.018-3.108m7.346-2.989c0-1.265-0.043-2.037-0.95-3.019-0.789-0.863-2.052-1.325-3.214-1.325-1.784 0-3.539 1.206-3.985 2.991h1.07c0.64-1.205 1.606-1.934 3.003-1.934 1.044 0 2.128 0.474 2.662 1.411 0.357 0.641 0.357 1.16 0.357 1.876v0.444c-0.518-1.218-1.918-1.797-3.18-1.797-1.074 0-2.158 0.461-2.931 1.189-0.862 0.819-1.278 1.858-1.278 3.047 0 1.145 0.475 2.188 0.772 2.516 1.071 1.351 2.217 1.755 3.376 1.755 1.296 0 2.616-0.581 3.241-1.755v1.575h1.057z",
    clipPath: "url(#ag)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m438.25 243.97h-4.03v0.995h4.03z",
    clipPath: "url(#af)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m442.55 242.39c-0.029-0.834 0.639-1.533 1.473-1.533 0.789 0 1.428 0.55 1.428 1.351 0 0.983-0.776 1.342-1.577 1.563-0.519 0.164-1.071 0.328-1.473 0.716-0.433 0.386-0.655 0.965-0.655 1.545 0 1.323 1.071 2.277 2.35 2.277 1.22 0 2.248-1.014 2.248-2.204h-1.105c0 0.716-0.548 1.147-1.262 1.147-0.622 0-1.129-0.507-1.129-1.132 0-0.892 0.714-1.129 1.426-1.351 1.22-0.388 2.277-0.907 2.277-2.379 0-1.533-1.114-2.588-2.632-2.588-1.384 0-2.546 1.202-2.47 2.588z",
    clipPath: "url(#ae)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m451.16 244.01c0-1.74 1.43-3.151 3.169-3.151 1.815 0 3.12 1.488 3.12 3.257 0 0.892-0.298 1.62-0.95 2.245-0.58 0.55-1.369 0.893-2.17 0.893-1.8 0-3.169-1.475-3.169-3.244m7.394 0.106c0-2.319-1.876-4.312-4.225-4.312-2.306 0-4.27 1.872-4.27 4.206 0 2.364 1.89 4.301 4.27 4.301 2.258 0 4.225-1.937 4.225-4.195",
    clipPath: "url(#ad)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m463.16 247.14h-1.263v0.995h1.263c-0.073 1.828 1.116 2.841 2.901 2.856h0.21v-0.998h-0.21c-1.131 0-1.799-0.55-1.799-1.694v-0.164h2.023v-0.995h-2.023v-7.139h-1.102z",
    clipPath: "url(#ab)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m470.68 247.14h-1.694v0.995h1.694v2.856h1.099v-2.856h1.891v-0.995h-1.891v-7.139h-1.099z",
    clipPath: "url(#aa)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m476.44 248.13h1.16l2.555-6.813 1.891 5.818h0.907l1.873-5.818 2.604 6.813h1.159l-3.095-8.134h-1.263l-1.742 5.399-1.709-5.399h-1.265z",
    clipPath: "url(#z)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m492.9 244.03c0-1.784 1.545-3.166 3.287-3.166 1.697 0 3.154 1.457 3.154 3.151 0 1.8-1.369 3.244-3.184 3.244-1.784 0-3.257-1.429-3.257-3.229m7.494-4.028h-1.053v1.53h-0.03c-0.595-1.144-1.845-1.723-3.124-1.723-1.219 0-2.543 0.534-3.584 1.723-0.297 0.328-0.804 1.354-0.804 2.589 0 1.114 0.462 2.112 1.175 2.854 0.774 0.805 1.799 1.341 3.183 1.341 1.279 0 2.573-0.566 3.154-1.725h0.03v1.545h1.053z",
    clipPath: "url(#y)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m504.75 248.13h1.041v-1.174h0.03c0.404 0.965 1.339 1.323 2.334 1.354v-1.087c-0.595-0.043-1.011-0.179-1.471-0.565-0.756-0.64-0.833-1.189-0.833-2.112v-4.55h-1.101z",
    clipPath: "url(#x)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m518.7 244.67c-0.282 1.442-1.607 2.589-3.11 2.589-1.53 0-2.883-1.086-3.151-2.589zm-6.261-0.995c0.061-1.548 1.563-2.811 3.066-2.811 1.204 0 2.422 0.668 2.913 1.785h1.144c-0.564-1.638-2.23-2.84-3.957-2.84-2.38 0-4.264 1.872-4.264 4.252 0 2.364 1.87 4.255 4.236 4.255 1.278 0 2.453-0.581 3.272-1.579 0.759-0.937 0.92-1.887 0.951-3.062z",
    clipPath: "url(#w)",
    fill: "#5a5758"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m480.98 263.17v94.164h-66.032l5.694-94.164z",
    clipPath: "url(#v)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m467.65 282.29c-3.752-1.392-11.163-3.67-19.919-3.67-9.818 0-17.901 2.576-24.251 8.832-5.584 5.555-9.049 14.483-9.049 24.903 0.095 19.939 13.378 34.524 35.13 34.524 7.506 0 13.374-1.684 16.167-3.074l-2.022-7.045c-3.466 1.587-7.794 2.877-14.342 2.877-15.783 0-26.079-10.121-26.079-26.886 0-16.969 9.912-26.987 25.026-26.987 5.479 0 9.235 0.794 11.161 1.784v19.944h-13.188v6.945h21.366z",
    clipPath: "url(#u)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m514.87 264.1c1.054 1.66 1.931 4.082 1.931 6.632 0 3.784-2.059 5.992-5.041 5.992-2.763 0-4.34-1.528-5.87-5.394-1.709-4.679-4.209-7.569-8.376-7.569-4.598 0-8.018 3.697-8.018 9.267 0 2.935 0.701 5.057 1.447 6.332l3.113-1.018c-0.525-0.935-1.405-2.848-1.405-5.44 0-3.911 2.412-5.401 4.429-5.401 2.758 0 4.119 1.742 5.696 5.699 1.926 4.845 4.341 7.31 8.681 7.31 4.555 0 8.545-3.272 8.545-10.033 0-2.761-0.877-5.782-1.928-7.311z",
    clipPath: "url(#t)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m504.93 289.1c6.313 0 11.965 3.319 11.965 9.144 0 5.864-5.566 9.181-12.27 9.181-5.873 0-12.008-2.975-12.008-9.142 0-6.119 5.827-9.183 12.313-9.183m-0.482 22.237c10.168 0 15.562-5.993 15.562-13.307 0-7.569-6.049-12.883-14.987-12.883-9.384 0-15.519 5.657-15.519 13.309 0 7.822 6.183 12.881 14.944 12.881",
    clipPath: "url(#s)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m489.98 317.41v15.436h3.202v-11.734h9.814v10.84h3.156v-10.84h13.369v-3.702z",
    clipPath: "url(#q)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m493.23 344.83v-8.712h-3.245v21.212h3.245v-8.76h26.296v-3.74z",
    clipPath: "url(#p)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m398.71 308.68c-0.479 9.328-1.058 20.539-0.961 28.873h-0.288c-2.213-7.837-4.909-16.272-8.182-25.4l-11.452-32.444h-6.351l-10.493 31.85c-3.08 9.425-5.678 18.057-7.506 25.994h-0.191c-0.193-8.334-0.674-19.545-1.252-29.565l-1.734-28.673h-7.986l4.524 66.87h10.682l11.067-32.346c2.694-8.234 4.909-15.576 6.546-22.521h0.287c1.637 6.748 3.947 14.089 6.833 22.521l11.551 32.346h10.679l4.044-66.87h-8.18z",
    clipPath: "url(#o)",
    fill: "#2350a9"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m325.37 272.55c-2.588 0-4.692-2.103-4.692-4.694 0-2.586 2.104-4.69 4.692-4.69 2.589 0 4.693 2.104 4.693 4.69 0 2.591-2.104 4.694-4.693 4.694",
    clipPath: "url(#n)",
    fill: "#2350a9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m341.47 272.55c-2.586 0-4.694-2.103-4.694-4.694 0-2.586 2.108-4.69 4.694-4.69 2.587 0 4.693 2.104 4.693 4.69 0 2.591-2.106 4.694-4.693 4.694",
    clipPath: "url(#l)",
    fill: "#2350a9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m357.58 272.55c-2.588 0-4.692-2.103-4.692-4.694 0-2.586 2.104-4.69 4.692-4.69 2.587 0 4.692 2.104 4.692 4.69 0 2.591-2.105 4.694-4.692 4.694",
    clipPath: "url(#j)",
    fill: "#2350a9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m373.68 272.55c-2.587 0-4.692-2.103-4.692-4.694 0-2.586 2.105-4.69 4.692-4.69s4.693 2.104 4.693 4.69c0 2.591-2.106 4.694-4.693 4.694",
    clipPath: "url(#h)",
    fill: "#2350a9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m389.78 272.55c-2.586 0-4.694-2.103-4.694-4.694 0-2.586 2.108-4.69 4.694-4.69 2.587 0 4.693 2.104 4.693 4.69 0 2.591-2.106 4.694-4.693 4.694",
    clipPath: "url(#f)",
    fill: "#2350a9"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.3333 0 0 -1.3333 0 793.7)",
    d: "m405.89 272.55c-2.589 0-4.694-2.103-4.694-4.694 0-2.586 2.105-4.69 4.694-4.69 2.587 0 4.692 2.104 4.692 4.69 0 2.591-2.105 4.694-4.692 4.694",
    clipPath: "url(#c)",
    fill: "#2350a9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSvgmin);
export default __webpack_public_path__ + "static/media/logoSVGMIN.6e25e0c6e8913adf9919a8571cac0e92.svg";
export { ForwardRef as ReactComponent };